/* eslint-disable linebreak-style */
/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import NavLink from 'components/NavLink';
import Icon from 'base-ui/dist/Icon';
import { FormattedMessage } from 'react-intl';
import DateFormat from 'components/DateFormat';
import messages from './messages';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const AuthorSignedCard = ({ author, reviewed_by }) => {
  if (author.type === 'professional') {
    return (
      <div className="single-assigned message with-icon blue-border good">
        <Icon className="icon" prefix="fas" color="blue" name="check-double" />
        <FormattedMessage
          {...messages.redactedAndSigned}
          values={{
            profession: author.profession,
            name:
  <NavLink
    basePath={publicRuntimeConfig.PUBLIC_URL}
    as={`${author?.permalink}`}
    to={`/author?slug=${author.slug}`}
    className="highlight blue-border"
    routerStrategy={'next'}
  >
    {author.name}
  </NavLink>
          }}
        />
      </div>
    );
  }

  if (reviewed_by) {
    return (
      <div className="single-assigned message with-icon blue-border good">
        <Icon className="icon" prefix="fas" color="blue" name="check-double" />
        <FormattedMessage
          {...messages.signed}
          values={{
            profession: reviewed_by.profession,
            name:
  <NavLink
    basePath={publicRuntimeConfig.PUBLIC_URL}
    as={`${reviewed_by?.permalink}`}
    to={`/author?slug=${reviewed_by.slug}`}
    className="highlight blue-border"
    routerStrategy={'next'}
  >
    {reviewed_by.name}
  </NavLink>,
            date: <strong><DateFormat>{reviewed_by.signed_date}</DateFormat></strong>
          }}
        />
      </div>
    );
  }

  return null;
};

AuthorSignedCard.propTypes = {
  author: PropTypes.object,
  reviewed_by: PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string,
    slug: PropTypes.string,
    permalink: PropTypes.string,
    signed_date: PropTypes.string,
    profession: PropTypes.string,
  })
};

export default AuthorSignedCard;
